import { Trash2 } from "lucide-react";
import { NeuInput } from "../../components/neu/Neu";

// جدول المواد المضافة داخل نموذج المناقلة — كل صف بحد أقصى الرصيد المتاح.
export const TransferLines = ({ lines, setLines }) => (
  <div className="grid gap-2">
    {lines.map((l, i) => (
      <div key={i} className="grid grid-cols-5 items-center gap-2 rounded-2xl bg-emerald-500/10 p-2 text-xs">
        <span className="col-span-2 font-bold">{l.item_name}</span>
        <NeuInput dir="ltr" data-testid={`trf-qty-${i}`} value={l.qty} type="number" max={l.max}
                  onChange={(e) => setLines(lines.map((x, ix) =>
                    ix === i ? { ...x, qty: Math.min(Number(e.target.value) || 0, l.max) } : x))} />
        <span className="num font-mono text-[10px] text-muted-foreground">/{l.max}</span>
        <button onClick={() => setLines(lines.filter((_, ix) => ix !== i))}>
          <Trash2 className="h-4 w-4 text-rose-500" /></button>
      </div>
    ))}
  </div>
);
